import { FilterListProps } from "../../types/FilterListProps";
import { FilterListItem } from "./FilterListItem";

export const FilterList = (props: FilterListProps) => (
    <>
       { props.items.map((filterListItem) => <FilterListItem {...filterListItem}/>) }
    </>
)